import type { AnalyticsEventStatus, AnalyticsLifecycleState, AnalyticsPlatform } from '@/api/generated/api'

export const LIFECYCLE_STATES: AnalyticsLifecycleState[] = ['draft', 'active', 'deprecated']
export const STATUS_VALUES: AnalyticsEventStatus[] = ['needs_publish', 'not_implemented', 'implemented']
export const PLATFORMS: AnalyticsPlatform[] = ['desktop', 'ios', 'android']

export const STATUS_CLASS_MAP: Record<AnalyticsEventStatus, string> = {
  needs_publish: 'needsPublish',
  not_implemented: 'notImplemented',
  implemented: 'implemented',
}

export const NEW_EVENT_ID_PREFIX = 'new-'

export const FIELD_LABELS: Record<string, string> = {
  name: 'Name',
  description: 'Description',
  trigger: 'Trigger',
  platforms: 'Platforms',
  lifecycle_state: 'Lifecycle',
  properties_schema: 'Properties Schema',
}
